import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Logo from "@/components/Logo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, error: "" });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, error: "Missing token" });
      return;
    }
    api
      .post("/customer/verify-email", { token })
      .then(() => setState({ loading: false, ok: true, error: "" }))
      .catch((err) => setState({ loading: false, ok: false, error: err?.response?.data?.detail || "Verification failed" }));
  }, [token]);

  return (
    <div className="min-h-[calc(100vh-80px)] grid place-items-center px-6 py-16" data-testid="verify-page">
      <div className="w-full max-w-md text-center">
        <div className="flex flex-col items-center text-center">
          <Logo variant="monogram" className="h-14 w-14 dark:invert" loading="eager" />
        </div>
        <div className="mt-10">
          {state.loading && (
            <div className="flex flex-col items-center gap-4" data-testid="verify-loading">
              <Loader2 className="h-8 w-8 animate-spin" />
              <p className="label-xs opacity-70">Verifying your email…</p>
            </div>
          )}
          {!state.loading && state.ok && (
            <div className="flex flex-col items-center gap-4" data-testid="verify-success">
              <CheckCircle2 className="h-10 w-10" />
              <h1 className="text-4xl font-serif tracking-tighter">Email verified.</h1>
              <p className="text-sm opacity-70 max-w-sm">
                Thanks for confirming your email — welcome to THE FABRICS.
              </p>
              <Link to="/account" className="mt-4 label-xs link-underline">
                Go to my account
              </Link>
            </div>
          )}
          {!state.loading && !state.ok && (
            <div className="flex flex-col items-center gap-4" data-testid="verify-error">
              <XCircle className="h-10 w-10" />
              <h1 className="text-3xl font-serif tracking-tighter">Verification failed</h1>
              <p className="text-sm opacity-70">{state.error}</p>
              <Link to="/account" className="mt-4 label-xs link-underline">
                Sign in and request a new link
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
